import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import { SmsFormDto } from "./refer.type";
import SmsService from "@/services/sms.service";

@Module({ namespaced: true })
class Refer extends VuexModule {
  form = new SmsFormDto();

  @Action({ rawError: true })
    async queueReferMessage(form: SmsFormDto): Promise<void> {
      await SmsService.createReferMessageAsync(form);
    }
}

Refer.getters = { getField };
Refer.mutations = { updateField };

export default Refer;